import { Component } from "@angular/core";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-icon-gallery",
  templateUrl: "./icon-gallery.component.html",
  styleUrls: ["./icon-gallery.component.scss"],
  standalone: false,
})
export class IconGalleryComponent {
  iconList = [
    "help",
    "logout",
    "setting",
    "user",
    "home",
    "feedback-resolved",
    "feedback-un-resolved",
    "go-back",
    "conceptx",
    "screenplay",
    "shotlist",
    "storyboard",
    "moodboard",
    "voiceover",
    "videox",
    "check-green",
    "phone",
    // Navigation icons
    "folder",
    "search",
    "settings",
    "menu",
    "grid",
    "list",
    "layers",
    // Action icons
    "plus",
    "x",
    "check",
    "edit",
    "trash",
    "copy",
    "download",
    "upload",
    "share",
    "refresh",
    "external-link",
    "more-horizontal",
    "more-vertical",
    // Media & Video icons
    "play",
    "pause",
    "skip-forward",
    "skip-back",
    "video",
    "film",
    "camera",
    "image",
    "mic",
    "volume",
    // AI & Production icons
    "ai-sparkle",
    "zap",
    "cpu",
    "brain",
    "clapperboard",
    "wand",
    "workflow",
    "timeline",
    // Communication icons
    "message",
    "mail",
    "bell",
    "users",
    "at-sign",
    // Status & Feedback icons
    "alert-circle",
    "check-circle",
    "x-circle",
    "info",
    "loader",
    "eye",
    // Arrows & Chevrons
    "chevron-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "arrow-up",
    "arrow-down",
    "arrow-left",
    "arrow-right",

    // Crown
    "crown",

    //social media
    "facebook",
    "google",
    "linkedin",

    "bill-and-payment",
    "clock",
    "star",
    "dollar",
    "lighting",
    "book",
    "notebook",
    "file",
    "anchor",
    "pulse",
    "shield",
    "calender",
    "graduation-cap",
    "location",
    "billinfo",
    "invoice",
    "save",
    "dot",
    "empty-circle",
    "point-of-view",
    "edit-square",
    "drag-handle",
    "send",
    "gallery",
    "shotpreview",
    "object",
    "regenrate",
    "hexagon",
    "prevbutton",
    "nextbutton",
    "lock",
    "unlock",
    "goto",
    "square",
    "music"
  ];
  searchTerm: string = "";

  constructor(private sharedService: SharedService) {}

  get filteredIcons(): string[] {
    const term = this.searchTerm.toLowerCase().trim();
    if (!term) return this.iconList;
    return this.iconList.filter((icon) => icon.toLowerCase().includes(term));
  }

  copyIcon(iconName: string): void {
    const iconCode = `<app-icon name="${iconName}" size="32" color="#1677ff"></app-icon>`;
    navigator.clipboard.writeText(iconCode).then(
      () => {
        this.sharedService.messageToastNotification(
          "success",
          "Copied to clipboard!",
        );
      },
      (err) => {
        console.error("Could not copy text: ", err);
      },
    );
  }
}
